import { render, staticRenderFns } from "./addDialog.vue?vue&type=template&id=cddcfdee&scoped=true&"
import script from "./addDialog.vue?vue&type=script&lang=ts&"
export * from "./addDialog.vue?vue&type=script&lang=ts&"
import style0 from "./addDialog.vue?vue&type=style&index=0&id=cddcfdee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddcfdee",
  null
  
)

export default component.exports